import React from 'react'
import { injectIntl } from "gatsby-plugin-intl"


class Title extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            expandedLanguages: false
        }
    }

    render() {
        const { intl } = this.props
        return (
                <div className="container">
                    <div className="auto-col-2">
                        <div className="col-item col-item-top-title">
                            <div className="box-right">
                                <div className="bankinvoice-banned bankinvoice-title">Bank Invoice</div>
                                <div className="bankinvoice-banned" >Blockchain Network Worldwide</div>
                            </div>
                        </div>
                        <div className="col-item">
                            <div className="box-left">
                                <h2 
                                    className="bankinvoice-banned-connect"
                                    style={{
                                    color: "#777"
                                }}>{ intl.formatMessage({id: "connect"}) }</h2>
                                <div className="bankinvoice-banned-description">{ intl.formatMessage({id: "description"}) }</div>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}
export default injectIntl(Title)

